import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { HROUTES } from './navigation-routes.config';
import { LayoutService } from '../services/layout.service';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@auth/auth.service';
import Utils from '@shared/utils/utils';
import { SpinnerService } from '@core/spinner/spinner.service';
import { finalize } from 'rxjs/operators';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MfaRegisterComponent } from '../../routes/auth/mfa/mfa-register/mfa-register.component';


@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  user: any = null;
  public menuItems: any[];
  public config: any = {};

  logoUrl = 'assets/img/logo.png';
  logoTextUrl = 'assets/img/logo.text.png';
  collapseSidebar = false;

  level: number = 0;
  transparentBGClass = "";
  menuPosition = 'Top';

  layoutSub: Subscription;

  constructor(private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    public modalService: NgbModal) {
    this.config = this.configService.templateConf;
    this.user = this.authService.getToken()?.user;
  }

  ngOnInit() {
    this.updateMenu();
  }

  updateMenu() {
    const isLoggedIn = this.authService.isAuthenticated();

    this.menuItems = HROUTES.filter(item => {
      if (item.path === '/auth/login' && isLoggedIn) {
        return false;
      }
      if (item.path === '/dashboard' && !isLoggedIn) {
        return false;
      }
      return true;
    });
  }

  ngAfterViewInit() {
    this.layoutSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() != "") {
      this.menuPosition = this.config.layout.menuPosition;
    }


    if (this.config.layout.variant === "Transparent") {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    }
    else {
      this.transparentBGClass = "";
    }

  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

  logout() {
    Utils.showConfirm('Do you want to sign out?', 'Sign out', 'Cancel')
      .then(x => {
        if (x === 'Sign out') {
          this.authService.logout();
        }
      });
  }

  registerMfa() {
    this.spinnerService.start();
    this.authService.qrCode()
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(result => {
        const { qrCode } = result;
        const initialState = {
          qrCode,
        };

        const options: NgbModalOptions = {
          size: 'lg',
          backdrop: 'static',
        }

        const modalRef = this.modalService.open(MfaRegisterComponent, options);
        modalRef.componentInstance.qrCode = qrCode;
        modalRef.result.then(result => {
          if (result) {
            Utils.showMessage('MFA device registered successfully.')
          }
        });
      });
  }

}
